import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/organizations/search', { params: request })
  },
  find: function (id) {
    return axios.get('/api/organizations/find?id='+id)
  }
}